export const regular = {
  // 验证自然数
  //   /^(([0-9]*[1-9][0-9]*)|(0+)){0,2}$/
  naturalNumber: /^[0-9]{1,2}$/,
  naturalNumberMsg: '请输入1-2位数字',
  // 座机
  telephone: /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/,
  telephoneMsg: '请输入正确的座机号',
  // 银行卡号码
  bankCard: /^[1-9]\d{9,19}$/,
  bankCardMsg: '请输入正确的银行卡号码',
  // 证件号码
  IDNumber: /^[a-z0-9A-Z]{0,50}$/,
  IDNumberMsg: '请输入正确的证件号码',
  // 身份证号码,包括15位和18位的
  // IDCard: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{7}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
  IDCard: function (rule, value, callback) {
    // eslint-disable-next-line no-array-constructor
    var Errors = new Array(
      '验证通过!',
      '身份证号码位数不对!',
      '身份证号码出生日期超出范围或含有非法字符!',
      '身份证号码校验错误!',
      '身份证地区非法!'
    )
    var idcard = value.replace(/\s+/g, '')
    var area = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    }
    var Y, JYM, ereg
    var S, M
    // var idcard_array = new Array()
    var idcard_array = idcard.split('')
    // 地区检验
    if (area[parseInt(idcard.substr(0, 2))] == null) {
      return callback(new Error(Errors[4]))
    }

    // 身份号码位数及格式检验
    switch (idcard.length) {
      case 15:
        if (
          (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 ||
          ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 &&
            (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)
        ) {
          ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/ // 测试出生日期的合法性
        } else {
          ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/ // 测试出生日期的合法性
        }
        if (ereg.test(idcard)) return callback()
        else return callback(new Error(Errors[2]))
      // break
      case 18:
        // 18位身份号码检测
        // 出生日期的合法性检查
        // 闰年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))
        // 平年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))
        if (
          parseInt(idcard.substr(6, 4)) % 4 == 0 ||
          (parseInt(idcard.substr(6, 4)) % 100 == 0 &&
            parseInt(idcard.substr(6, 4)) % 4 == 0)
        ) {
          ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/ //闰年出生日期的合法性正则表达式
        } else {
          ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/ //平年出生日期的合法性正则表达式
        }
        if (ereg.test(idcard)) {
          // 测试出生日期的合法性
          // 计算校验位
          S =
            (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 +
            (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 +
            (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 +
            (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 +
            (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 +
            (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 +
            (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 +
            parseInt(idcard_array[7]) * 1 +
            parseInt(idcard_array[8]) * 6 +
            parseInt(idcard_array[9]) * 3

          Y = S % 11
          M = 'F'
          JYM = '10X98765432'
          M = JYM.substr(Y, 1) // 判断校验位

          if (M === idcard_array[17]) {
            return callback()
          } else {
            return callback(new Error(Errors[3]))
          }
          // 检测ID的校验位
        } else {
          return callback(new Error(Errors[2]))
        }
      // break
      default:
        return callback(new Error(Errors[1]))
    }
  },
  IDCardMsg: '请输入正确的身份证号码',
  phone: /(^1[3|4|5|6|7|8|9][0-9]{9}$)/,
  phoneMsg: '请输入正确的联系方式',

  // 0到20位的英文字符和数字
  enNum0to20: /^[a-z0-9A-Z]{0,20}$/,
  enNum0to20Msg: '请输入20位以内的英文字符和数字',
  // 2到100位的中英文字符和空格
  cnEnSpace2to100: /^[a-zA-Z\u4E00-\u9FA5\s*]{2,100}$/,
  cnEnSpace2to100Msg: '请输入2到100位的中英文字符和空格',
  // 数字和换行符
  numLinefeed: /^[0-9\n*]+$/,
  numLinefeedMsg: '请输入数字和换行符',
  // 255位以内的字符
  char0to255: /^.{0,255}$/,
  char0to255Msg: '请输入255位以内的字符'
}
/**
 * @description 排序值验证，排序值不可以大于255
 */
export const validateOrder = function (rule, value, callback) {
  if (parseInt(value) > 255) {
    return callback(new Error('排序值不可以大于255'))
  } else {
    callback()
  }
}
export const CheckSocialCreditCode = function (rule, value, callback) {
  var patrn = /^[0-9A-Z]+$/ // 18位校验及大写校验
  if (value === '') {
    callback(new Error('请输入社会统一信用代码'))
  } else if (value.length !== 18 || patrn.test(value) === false) {
    // return false
    return callback(new Error('统一信用代码不正确'))
  } else {
    var Ancode // 统一社会信用代码的每一个值
    var Ancodevalue // 统一社会信用代码每一个值的权重
    var total = 0
    var weightedfactors = [
      1,
      3,
      9,
      27,
      19,
      26,
      16,
      17,
      20,
      29,
      25,
      13,
      8,
      24,
      10,
      30,
      28
    ] // 加权因子
    var str = '0123456789ABCDEFGHJKLMNPQRTUWXY' // 不用I、O、S、V、Z
    for (var i = 0; i < value.length - 1; i++) {
      Ancode = value.substring(i, i + 1)
      Ancodevalue = str.indexOf(Ancode)
      total = total + Ancodevalue * weightedfactors[i] // 权重与加权因子相乘之和
    }
    var logiccheckcode = 31 - (total % 31)
    if (logiccheckcode === 31) {
      logiccheckcode = 0
    }
    var Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y'
    // eslint-disable-next-line camelcase
    var Array_Str = Str.split(',')
    logiccheckcode = Array_Str[logiccheckcode]
    var checkcode = value.substring(17, 18)
    if (logiccheckcode !== checkcode) {
      callback(new Error('请输入正确统一信用代码'))
    }
    callback()
    // return true
  }
}
export const CheckOrganization = function (rule, value, callback) {
  value = value.replace(/-/g, '').trim()
  if (value === '') {
    // return callback()
    callback(new Error('请输入组织机构代码'))
  } else if (value.length !== 9) {
    callback(new Error('组织机构代码不正确'))
  } else {
    var reg = /^[0-9A-Z]+$/
    if (reg.test(value) === false) {
      callback(new Error('组织机构代码只可为数字或大写拉丁字母'))
    } else {
      var regLast = /^[0-9X]+$/

      var lastnum = value.substring(8, 9)

      if (regLast.test(lastnum) === false) {
        // alert("组织机构代码最后一位只可为数字或大写拉丁字母:X");
        callback(new Error('组织机构代码最后一位只可为数字或大写拉丁字母 X'))
      } else {
        var ancode
        var ancodeWeightValue
        var sum = 0
        var weightedArray = [3, 7, 9, 10, 5, 8, 4, 2] // 加权因子
        var str = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for (var i = 0; i < value.length - 1; i++) {
          ancode = value.substring(i, i + 1)
          ancodeWeightValue = str.indexOf(ancode)
          sum = sum + ancodeWeightValue * weightedArray[i]
        }
        var rightLastnum = 11 - (sum % 11)
        if (rightLastnum === 10) rightLastnum = 'X'
        if (rightLastnum === 11) rightLastnum = '0'
        if (lastnum != rightLastnum) {
          callback(new Error('请输入正确组织机构代码'))
        } else {
          callback()
        }
      }
    }
  }
}

export const CheckZongjiao = function (rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入宗教编码'))
  }
  if (value.length < 11) {
    callback(new Error('宗教编码位数不正确'))
  }
  if (value.substr(0, 1) !== '陕') {
    callback(new Error('宗教编码头验证失败'))
  }
  var val = value.substr(1, 1)

  var reg = /^[A-Z]+$/
  if (reg.test(val) === false) {
    callback(new Error('宗教编码第二位验证失败'))
  }

  var val1 = value.substr(2)
  var reg1 = /^[0-9]+$/
  if (reg1.test(val1) === false) {
    callback(new Error('宗教编码验证失败'))
  }

  callback()
}
export const CheckLicense = function (rule, value, callback) {
  var patrn = /^[0-9]+$/
  if (value === '') {
    // return callback()
    callback(new Error('请输入工商执照号'))
  }

  if (value.length === 13) {
    if (patrn.test(value) === false) {
      callback(new Error('工商执照号位数不正确'))
    }
  } else if (value.length === 15) {
    // 15
    if (!businessLicense15(value)) {
      callback(new Error('工商执照号不正确'))
    }
  } else {
    callback(new Error('工商执照号不正确'))
  }

  callback()
}

export function getChecklenseceCode(code) {
  let ti = 0
  let si = 0 // pi|11+ti
  let cj = 0 // （si||10==0？10：si||10）*2
  let pj = 10 // pj=cj|11==0?10:cj|11
  for (let i = 0; i < code.length; i++) {
    ti = code[i]
    pj = cj % 11 === 0 ? 10 : cj % 11
    si = pj + ti
    cj = si % 10 === 0 ? 10 : (si % 10) * 2

    if (i === code.length - 1) {
      pj = cj % 11 === 0 ? 10 : cj % 11
      // console.log(pj === 1 ? 1 : 11 - pj)
      return pj === 1 ? 1 : 11 - pj
    }
  }
  return -1
}
export function businessLicense15(ints) {
  let ti = 0

  let si = 0
  // pi|11+ti

  let cj = 0
  // （si||10==0？10：si||10）*2

  let pj = 10
  // pj=cj|11==0?10:cj|11

  let lastNum = ''

  for (let i = 0; i < ints.length; i++) {
    ti = parseInt(ints[i])

    si = pj + ti

    cj = (0 == si % 10 ? 10 : si % 10) * 2

    pj = cj % 11

    if (i == ints.length - 1) {
      //lastNum =(1 - pj < 0 ? 11 - pj : 1 - pj) % 10;

      lastNum = si % 10
    }
  }
  if (lastNum == 1) {
    return true
  } else {
    return false
  }
}
export const dzqc = function (rule, value, callback) {
  if (value.slice(value.length - 1) != '号') {
    callback(new Error('详细地址最后一位必须为号'))
  } else {
    callback()
  }
}